import React from 'react';
import { Container, Table } from 'react-bootstrap';

const Performance = ({ data }) => {
  // Define sort order
  const sortOrder = ['1D', '1W', '1M', '6M', '1Y', '2Y', '5Y', '10Y'];

  const filteredData = data.filter(item => sortOrder.includes(item.Return_Period));
  // Sort data
  const sortedData = filteredData.sort((a, b) => sortOrder.indexOf(a.Return_Period) - sortOrder.indexOf(b.Return_Period));

  // Render component
  return (
    <Container>
      <h3>Performance</h3>
      <Table striped bordered responsive>
        <thead>
          <tr>
            <th>Return Period</th>
            <th style={{ textAlign: 'right' }}>Return (%)</th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((item, index) => (
            <tr key={index}>
              <td className="tableitem">{item.Return_Period}</td>
              <td className="tableitem" style={{ textAlign: 'right' }}>
                {typeof item.ReturnByCurrency_Value !== "undefined" && item.ReturnByCurrency_Value != null && !isNaN(item.ReturnByCurrency_Value) ? item.ReturnByCurrency_Value.toFixed(2) : ''}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
}

export default Performance;